module.exports = __webpack_public_path__ + "static/img/password.6621aad.svg";


//////////////////
// WEBPACK FOOTER
// ./static/icons/password.svg
// module id = jXxz
// module chunks = 1